import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { HttpService } from "../../service/HTTPService/HttpService";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import {
  NgbModal,
  ModalDismissReasons,
  NgbDate,
  NgbCalendar,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import {
  ChartCreated,
  ChartDestroyed,
  ChartOptionsChanged,
  ChartRangeSelectionChanged,
  ColDef,
  ExcelExportParams,
  ExcelRow,
  ExcelStyle,
  Grid,
  GridApi,
  GridOptions,
  Module,
  SideBarDef,
} from "ag-grid-community";
import { Globals } from "../../globals";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import $ from "jquery";
import * as Highcharts from "highcharts";

import * as moment from "moment";
import { CustomReportActionComponent } from "../actionsRenderer/customAction.component";
import Swal from "sweetalert2";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import { DateTimeAdapter } from "ng-pick-datetime";
import { LoggingService } from "../../service/LoggingService/loggingService";
const FileSaver = require("file-saver");

@Component({
  selector: "app-custom-report",
  templateUrl: "./custom-report.component.html",
  styleUrls: ["./custom-report.component.scss"],
})
export class CustomReportComponent implements OnInit, AfterViewInit {
  gridOptions: GridOptions;
  userAddressValidations: FormGroup;
  selectedReportType: string = "";
  mandatorySite = true;
  mandatoryDate = true;
  responceEquipment: Array<any> = [];
  responceEquipment2: any;
  responceEquipment3: any;
  responceEquipment4: any;
  responceEquipment5: any;
  responceEquipment6: any;
  responceEquipment7: any;
  responceEquipment8: any;
  responceEquipment9: any;
  responceEquipment10: any;
  responceEquipment11: any;
  count = 0;
  customReportRequestJson: any;
  Columns: Array<any> = [];
  EqupmentID: any;
  tableColumns: Array<any> = [];
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  hoveredDate: NgbDate;
  gridApi;
  showGridLoader: Boolean = false;
  gridRecordSize;
  fromDate;
  fromDate1;
  toDate;
  toDate1;
  dateRange = "";
  FromDate;
  ToDate;
  FromDateGen;
  ToDateGen;
  StartDate = "";
  EndDate = "";
  headers: any[] = [];
  rowData: any[] = [];
  columnDefs;
  public modules: Module[];
  gridData: any[] = [];
  public Switch: boolean = false;
  public Header1: boolean = false;
  public Header2: boolean = false;
  public Header3: boolean = false;
  public Header4: boolean = false;
  public Header5: boolean = false;
  public Header6: boolean = false;
  public Header7: boolean = false;
  public Header8: boolean = false;
  public Header9: boolean = false;
  public Header10: boolean = false;
  public Header11: boolean = false;
  EquipmentDropdown: boolean = false;
  hideCircleClustorDropdown: boolean = false;
  EquipDropdown: any;
  fromdate: NgbDate;
  todate: NgbDate;
  reportname = "";
  getSavedReports: any;
  selectedSavedReport: any;
  getSitedetails: any;
  selectedSitIDItems = undefined;
  selectedReportTypes: any;
  disableExport: boolean = true;
  disablelastbutton = false;
  gridData1 = [];
  startDt;
  endDt;
  EquipmentTypes: any;
  EquipmentName1: any;
  EquipmentName2: any;
  EquipmentName3: any;
  EquipmentName4: any;
  EquipmentName5: any;
  EquipmentName6: any;
  EquipmentName7: any;
  EquipmentName8: any;
  EquipmentName9: any;
  EquipmentName10: any;
  EquipmentName11: any;
  ReportTypes: any;
  checked: boolean = true;
  alerts: any[] = [];
  TimeType: any;
  closeResult: string;
  EquipmentIds: any[] = [];
  Date = false;
  currentIndex = 0;
  ReportTypeName: any;
  SavedrepId: any;
  dynamicaDataValues;
  Savedrep: any;
  frm: any;
  end: any;
  SummaryDetails: boolean = false;
  public form: FormGroup;
  public loadContent: boolean = false;
  afterFromDate: boolean = true;
  public name = "Cricketers";
  public settings = {};
  public settings1 = {};
  public settings2 = {};
  public settings3 = {};
  public selectedItems = [];
  GetSiteIdDetails: any;
  paginationPageSize;
  paginationNumberFormatter;
  standardStartDate;
  standardEndDate;
  recordSize;
  pageNumber;
  reportTimeType;
  reportCatageryType;
  showRegionDropDown = false;
  showClusterDropDown = false;
  arr: any[] = [];
  selectedAxies1: boolean = true;
  selectedAxies2: boolean = true;
  showAxis: boolean = false;
  reportType;
  genChartPara;
  chartData: any[];
  finalarr: any[] = [];
  chartOptions;
  chartxparam: any[] = [];
  selectedCity = "spline";
  public defaultColDef: ColDef;
  _opened: boolean = false;
  Highcharts;
  sec: any = [];
  isDataAvailableRepchart: boolean = false;
  isDataAvailableReport: boolean = false;
  scheduleBtnEnbDsb: boolean = true;
  selectedCheckbox: any[] = [];
  selectedCheckbox1: any;
  cbChecked: string[];
  cbChecked1: string[];
  seriesData: any[] = [];
  seriesData1: any[] = [];
  axisX: any[] = [];
  axisY: any[] = [];
  frameworkComponents: any;
  dateTimeFormat;
  data = [
    { item_id: 1, item_text: "Hanoi" },
    { item_id: 2, item_text: "Lang Son" },
    { item_id: 3, item_text: "Vung Tau" },
    { item_id: 4, item_text: "Hue" },
    { item_id: 5, item_text: "Cu Chi" },
  ];
  indexs: any[] = [];
  removeIndex: any[] = [];
  firstArray: any[] = [];
  SecondArray: any[] = [];
  ThirddArray: any[] = [];
  FourthArray: any[] = [];
  columnDefsSample: any[] = [];
  selectedClustorCircleZone: any;
  selectedRegion = "";
  selectedCluster = "";
  montharr: any[] = [];
  selectedDateFormat;
  selectedTimeFormat;
  rowDatasample: any[] = [];
  maxUpdatedDate;
  editTableRow: any;
  addRetportTypeText: any;
  SiteDropdown: boolean = false;
  ClustorZoneDropdown: boolean = false;
  FromDateHide: boolean = false;
  ToDateHide: boolean = false;
  showMonthlyDD: boolean = false;
  GenerateClearEnable: boolean = false;
  ScheduleEnable: boolean = false;
  showdateTimePicker: boolean = false;
  fromDateVal = "From Date";
  Acmeter: boolean = false;
  Dcmeter: boolean = false;
  powerPlant: boolean = false;
  selectedPowerPlant;
  selectedController;
  selectedGeneratorController;
  selectedRectifierController;
  selectedBatteryController;
  selectedTenant;
  metername;
  slectedacmeter: any;
  selectedDcmeter: any;
  arrayAcmeter: any[] = [];
  arrayDcmeter: any[] = [];
  selectedPowerPlantID;
  dcmeterparams: boolean = false;
  RequestGenerateData: any;
  FromDates: any;
  EndDates: any;
  sop: any;
  SelectedClustorZone: any;
  selectedStartMonth: any;
  FromToDateHistory: boolean = false;
  MonthHistory: boolean = false;
  SiteIdsDisplay: boolean = false;
  hide: Boolean = false;
  slection = true;
  AcmeterValues;
  DcmeterValues;
  powerPlantValues;
  searchTenant;
  searchPowerPlant;
  searchController;
  searchGeneratorController;
  searchBatteryController;
  searchRectifierController;
  searchSite: any;
  getClustorZone: any;
  GetClustorZoneSieName: any;
  finalFromTime;
  finalToTime;
  getEmailCoolingClass;
  unique;
  getmailIdvalues: any[] = [];
  filterSearchListEdit: any[] = [];
  validMailId;
  filterSearchList: any[] = [];
  ScheduleRepdailySelectedTypeNum;
  ScheduleRepAccessability;
  scheduleRepName;
  groupByID = "0";
  EnableSheduleReport: boolean = false;
  selectedgetEmailClass: any[] = [];
  saveShedRepJSON: any;
  pageIndex = 0;
  lastPageFound;
  PageSize;
  currentPage = 0;
  totalPage;
  totalRowCount;
  selectedReportCategory;
  exportedReportslist;
  exportId = 0;
  selectedTimeType;
  selectedWeek: any;
  startOftheWeek;
  weekarr = [];
  showWeeklyDD: boolean = false;
  savedReportSelected = false;
  timeTypeListFiltered = [
    {
      TimeID: "1",
      TimeName: "Daily",
    },
    {
      TimeID: "3",
      TimeName: "Weekly",
    },
    {
      TimeID: "2",
      TimeName: "Monthly",
    },
  ];
  selectionParams = {
    tenantfilter: 1,
    PPFilter: 1,
    generatorControllerfilter: 1,
    rectifierControllerfilter: 1,
    batteryControllerfilter: 1,
  };
  public sideBar: SideBarDef | string | boolean | null = {
    toolPanels: ["columns", "filters"],
  };
  public excelStyles: ExcelStyle[] = [
    {
      id: "dateLong",
      dataType: "DateTime",
      numberFormat: {
        format: "dd/mm/yyyy hh:mm:ss",
      },
    },
    {
      id: "greenBackground",
      interior: {
        color: "#DFF0D8",
        pattern: "Solid",
      },
    },
    {
      id: "redFont",
      font: {
        fontName: "Calibri",
        underline: "Single",
        italic: true,
        color: "#D9534F",
      },
    },
    {
      id: "darkGreyBackground",
      interior: {
        color: "#4A4A4A",
        pattern: "Solid",
      },
      font: {
        fontName: "Calibri",
        color: "#FFFFFF",
      },
    },
    {
      id: "boldBorders",
      borders: {
        borderBottom: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 2,
        },
        borderLeft: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 2,
        },
        borderRight: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 2,
        },
        borderTop: {
          color: "#000000",
          lineStyle: "Continuous",
          weight: 2,
        },
      },
    },
    {
      id: "header",
      font: { size: 14, bold: true, color: "#FFFFFF" },
      interior: {
        color: "#2F75B5",
        pattern: "Solid",
      },
      borders: {
        borderBottom: {
          color: "#1F4E79",
          lineStyle: "Continuous",
          weight: 1,
        },
        borderLeft: {
          color: "#1F4E79",
          lineStyle: "Continuous",
          weight: 1,
        },
        borderRight: {
          color: "#1F4E79",
          lineStyle: "Continuous",
          weight: 1,
        },
        borderTop: {
          color: "#1F4E79",
          lineStyle: "Continuous",
          weight: 1,
        },
      },
    },
    {
      id: "bigHeader",
      interior: {
        color: "#1E8449",
        pattern: "Solid",
      },
      font: { size: 18, bold: true, color: "#FFFFFF" },
      alignment: {
        horizontal: "Center",
        vertical: "Center",
      },
    },
    {
      id: "stringType",
      dataType: "String",
    },
    {
      id: "headerStyle",
      font: { bold: true, color: "#FFFFFF" },
      interior: { color: "#2E86C1", pattern: "Solid" },
      alignment: { horizontal: "Center", vertical: "Center" },
    },
    {
      id: "subHeaderStyle",
      font: { bold: true, color: "#000000" },
      interior: { color: "#E8F0FE", pattern: "Solid" },
      alignment: { horizontal: "Left" },
    },
  ];
  public domLayout: "normal" | "autoHeight" | "print" = "autoHeight";
  showRecords = [
    { id: "10", value: "10" },
    { id: "20", value: "20" },
    { id: "50", value: "50" },
    { id: "100", value: "100" },
  ];
  _valueCheck = 0;
  @ViewChild("multiSelect") multiSelect;
  selectedDateRange: any;
  @ViewChild("tabset") tabset;
  recordsPerRequest;
  exportedId;
  disablePrevBtn = false;
  disableNextBtn: Boolean = false;
  // reportTypeData = [
  //   {
  //     id: "1",
  //     description: "Device Data - Live",
  //     reportTimeType: "1",
  //     reportType: "4",
  //   },
  //   {
  //     id: "6",
  //     description: "Device Data - History",
  //     reportTimeType: "1",
  //     reportType: "5",
  //   },
  //   {
  //     id: "2",
  //     description: "Daily Detailed",
  //     reportTimeType: "1",
  //     reportType: "2",
  //   },
  //   {
  //     id: "3",
  //     description: "Daily Summary",
  //     reportTimeType: "1",
  //     reportType: "3",
  //   },
  //   {
  //     id: "4",
  //     description: "Monthly Detailed",
  //     reportTimeType: "2",
  //     reportType: "2",
  //   },
  //   {
  //     id: "5",
  //     description: "Monthly Summary",
  //     reportTimeType: "2",
  //     reportType: "3",
  //   },
  // ];
  showtimeType: boolean = false;
  reportTypeData = [
    {
      id: "1",
      description: "Device Data - Live",
      reportTimeType: "1",
      reportType: "4",
    },
    {
      id: "6",
      description: "Device Data - History",
      reportTimeType: "1",
      reportType: "5",
    },
    {
      id: "2",
      description: "Analytical - Data",
      reportTimeType: "1",
      reportType: "2",
    },
    // {
    //   id: "5",
    //   description: "Summary",
    //   reportTimeType: "1",
    //   reportType: "3",
    // },
  ];

  // reportTimeType
  // 1 - Daily
  // 2 - Monthly

  // reportType
  // 1 - Raw
  // 2 - Detailed
  // 3 - summary
  CircleClustorZone: any = [
    {
      ID: "-1",
      Name: "Region",
    },
    {
      ID: "-2",
      Name: "Cluster",
    },
    {
      ID: "-3",
      Name: "Site",
    },
  ];

  columnDefss = [
    {
      headerName: "Report Name",
      field: "reportname",
      width: 350,
      chartDataType: "series",
      enablePivot: true,
    },
    {
      headerName: "Time Type",
      field: "reporttimetypename",
      width: 150,
      chartDataType: "series",
      enablePivot: true,
    },
    {
      headerName: "Report Type",
      field: "reporttypename",
      width: 150,
      chartDataType: "series",
      enablePivot: true,
      suppressSorting: true,
      suppressMenu: true,
      suppressColumnsToolPanel: true,
      suppressResize: true,
    },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: "actionRenderer",
      width: 100,
      suppressSorting: true,
      suppressMenu: true,
      suppressColumnsToolPanel: true,
      suppressResize: true,
    },
  ];

  loadDatatoTable() {
    this.http
      .get(this.urlAuthentication.reportsApi + this.apiUrl.getSavedReportsEdit)
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res);
          let rowDatas = JSON.parse(getResp);
          this.editTableRow = rowDatas.Data;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  selectedPublishUserType: any;
  selectedPublishUser: any;
  userTypes: any = [];
  users: any = [];
  selectedSavedReportId: any;

  constructor(
    private http: HttpService,
    private calendar: NgbCalendar,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService,
    private logger: LoggingService,
    private globals: Globals,
    dateTimeAdapter: DateTimeAdapter<any>,
  ) {
    this.exportId = 0;
    this.startOftheWeek = 0;
    let startDay = this.urlAuthentication.startOftheWeek;
    let startDayName = startDay.toLowerCase();
    switch (startDayName) {
      case "sunday":
        this.startOftheWeek = 0;
        break;
      case "monday":
        this.startOftheWeek = 1;
        break;
      case "tuesday":
        this.startOftheWeek = 2;
        break;
      case "wednesday":
        this.startOftheWeek = 3;
        break;
      case "thursday":
        this.startOftheWeek = 4;
        break;
      case "friday":
        this.startOftheWeek = 5;
        break;
      case "saturday":
        this.startOftheWeek = 6;
        break;
      default:
        break;
    }
    dateTimeAdapter.setLocale("en-IN");
    this.SiteDropdown = true;
    this.showdateTimePicker = true;
    this.maxDate = this.calendar.getToday();
    this.fromDate = calendar.getToday();
    this.maxUpdatedDate = new Date();
    this.fetchSavedRepoprt();
    this.fetchSites();
    this.getRegionData();
    this.getClusterData();
    this.getEmailIds();
    this.ReportTypes = [
      { IDs: "1", Names: "Detail" },
      { IDs: "2", Names: "Sumary" },
    ];
    this.selectedReportType = "0";
    this.cbChecked = [];
    this.paginationPageSize = 10;
    this.paginationNumberFormatter = function (params) {
      return "[" + params.value.toLocaleString() + "]";
    };
    this.recordsPerRequest = this.showRecords[0].id;
    this.gridRecordSize = this.showRecords[0].id;
    this.defaultColDef = {
      autoHeight: true,
      enableValue: true,
      enableRowGroup: true,
      enablePivot: true,
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      minWidth: 140,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      headerComponent: "sortableHeaderComponent",
      headerComponentParams: {
        menuIcon: "fa-bars",
      },
    };
    this.sideBar = {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
          },
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
    };
    this.gridOptions = <GridOptions>{
      context: {
        componentParent: this,
      },
    };
    this.frameworkComponents = {
      actionRenderer: CustomReportActionComponent,
    };
  }

  ReportTypeChange(event: any) {
    this.Columns = [];
    this.EquipmentIds = [];
    this.selectedItems = [];
    this.selectedReportTypes = event.target.value;

    const getselectedReport = this.reportTypeData.find((element) => {
      return element.id == this.selectedReportTypes;
    });
    this.reportTimeType = getselectedReport.reportTimeType;
    this.reportCatageryType = getselectedReport.reportType;
    if (
      event.target.value == "1" ||
      event.target.value == "2" ||
      event.target.value == "4" ||
      event.target.value == "6"
    ) {
      this.hideCircleClustorDropdown = false;
      this.EquipmentDropdown = true;
      this.EquipmentIds = [];
      this.Header2 = false;
      this.Header3 = false;
      this.Header4 = false;
      this.Header5 = false;
      this.Header6 = false;
      this.Header7 = false;
      this.Header8 = false;
      this.Header9 = false;
      this.Header10 = false;
      this.Header11 = false;
      this.selectedItems = [];
      this.Switch = false;
      // this.LoadEquipments();
      this.EquipDropdown = [];
      this.getEquipments();
      return false;
    }
    this.TimeType = event.target.value;
    this.hideCircleClustorDropdown = false;
    this.Columns = [];
    this.EquipmentIds = [];
    this.selectedItems = [];
    this.Switch = false;
    if (this.TimeType == "1") {
      this.EquipmentDropdown = true;
      this.selectedClustorCircleZone = "";
    } else {
      this.EquipmentDropdown = false;
      this.hideCircleClustorDropdown = true;
    }

    this.Header2 = false;
    this.Header3 = false;
    this.Header4 = false;
    this.Header5 = false;
    this.Header6 = false;
    this.Header7 = false;
    this.Header8 = false;
    this.Header9 = false;
    this.Header10 = false;
    this.Header11 = false;
    this.removeIndex = [];
    this.tableColumns = new Array();

    // this.LoadEquipments();
    this.EquipDropdown = [];
    this.getEquipments();
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  getequip(equipmentID, str, reportCategoryType) {
    let dataValue = {
      equipmentId: equipmentID,
      reportType: this.reportCatageryType,
    };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.getEquipmentConfigUrl,
        dataValue,
      )
      .subscribe(
        (res) => {
          let getImgResp = res.response;
          const autoCheckFields = ["Site Name", "Site ID", "Date & Time"];

          const filteredResp = getImgResp.filter((name) =>
            autoCheckFields.includes(name.fieldaliasname),
          );

          getImgResp.forEach((item) => {
            item.equipID = equipmentID;
            item.isChecked = autoCheckFields.includes(item.fieldaliasname);
            item.isDisabled = item.isChecked;
          });
          this.tableColumns = [];

          for (let i = 0; i < filteredResp.length; i++) {
            this.tableColumns.push({
              columnid: filteredResp[i].columnid,
              groupBy: "0",
            });
          }

          if (reportCategoryType == 3) {
            this.tableColumns.push({
              columnid: this.groupByID?.toString(),
              groupBy: "1",
            });
          }

          this.Columns.push({
            equipmentID: equipmentID,
            tableColumns: this.tableColumns,
          });

          let _val = this.getHeaders();
          this.switchF(_val, getImgResp, str);
        },
        (error) => {
          console.error(error);
        },
      );
  }
  getHeaders() {
    if (this.Header2 == false) {
      return "H2";
    } else if (this.Header3 == false) {
      return "H3";
    } else if (this.Header4 == false) {
      return "H4";
    } else if (this.Header5 == false) {
      return "H5";
    } else if (this.Header6 == false) {
      return "H6";
    } else if (this.Header7 == false) {
      return "H7";
    } else if (this.Header8 == false) {
      return "H8";
    } else if (this.Header9 == false) {
      return "H9";
    } else if (this.Header10 == false) {
      return "H10";
    } else if (this.Header11 == false) {
      return "H11";
    }
  }

  switchF(_val, getImgResp, gridname) {
    switch (_val) {
      case "H2":
        this.Header2 = true;
        this.responceEquipment2 = getImgResp;
        this.EquipmentName2 = gridname;
        break;
      case "H3":
        this.Header3 = true;
        this.responceEquipment3 = getImgResp;
        this.EquipmentName3 = gridname;
        break;
      case "H4":
        this.Header4 = true;
        this.responceEquipment4 = getImgResp;
        this.EquipmentName4 = gridname;
        break;
      case "H5":
        this.Header5 = true;
        this.responceEquipment5 = getImgResp;
        this.EquipmentName5 = gridname;
        break;
      case "H6":
        this.Header6 = true;
        this.responceEquipment6 = getImgResp;
        this.EquipmentName6 = gridname;
        break;
      case "H7":
        this.Header7 = true;
        this.responceEquipment7 = getImgResp;
        this.EquipmentName7 = gridname;
        break;
      case "H8":
        this.Header8 = true;
        this.responceEquipment8 = getImgResp;
        this.EquipmentName8 = gridname;
        break;
      case "H9":
        this.Header9 = true;
        this.responceEquipment9 = getImgResp;
        this.EquipmentName9 = gridname;
        break;
      case "H10":
        this.Header10 = true;
        this.responceEquipment10 = getImgResp;
        this.EquipmentName10 = gridname;
        break;
      case "H11":
        this.Header11 = true;
        this.responceEquipment11 = getImgResp;
        this.EquipmentName11 = gridname;
        break;
    }
  }

  onCheckboxChaged(event, value, ArryIndex) {
    this._valueCheck = 0;
    if (event.checked) {
      if (this.Columns.length > 0) {
        for (let key in this.Columns) {
          if (this.Columns[key].equipmentID == ArryIndex) {
            this.Columns[key].tableColumns.push({
              columnid: value?.toString(),
              groupBy: "0",
            });
            this._valueCheck = 1;
          }
        }
      }
    }
    if (event.checked == false) {
      if (this.Columns.length > 0) {
        for (let key in this.Columns) {
          let values = this.Columns[key];
          for (let keys in values.tableColumns) {
            if (values.tableColumns[keys].id == value) {
              let constkey = parseInt(keys);
              values.tableColumns.splice(constkey, 1);
              if (values.tableColumns.length >= 1) {
                this._valueCheck = 1;
              } else {
                this._valueCheck = 0;
              }
            }
          }
        }
      }
    }
  }

  LoadEquipments() {
    const reqJson = {
      reportType: this.reportCatageryType,
    };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.getEquipmentListUrl,
        reqJson,
      )
      .subscribe(
        (res) => {
          this.EquipDropdown = res.response;
          this.EquipmentDropdown = true;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  Generate(content4) {
    this.modalService.open(content4, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
    this.firstArray = [];
    this.SecondArray = [];
    this.ThirddArray = [];
    this.FourthArray = [];
    this.columnDefsSample = [];

    if (this.selectedReportType == "5") {
      if (this.Columns[1] != undefined) {
        for (let i = 1; i < this.Columns[1].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[1].tableColumns[i].Name,
            field: this.Columns[1].tableColumns[i].Name,
            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
      if (this.Columns[2] != undefined) {
        for (let i = 1; i < this.Columns[2].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[2].tableColumns[i].Name,
            field: this.Columns[2].tableColumns[i].Name,
            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
      if (this.Columns[3] != undefined) {
        for (let i = 1; i < this.Columns[3].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[3].tableColumns[i].Name,
            field: this.Columns[3].tableColumns[i].Name,
            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
      if (this.Columns[4] != undefined) {
        for (let i = 1; i < this.Columns[4].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[4].tableColumns[i].Name,
            field: this.Columns[4].tableColumns[i].Name,
            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
    } else {
      if (this.Columns[0] != undefined) {
        for (let i = 1; i < this.Columns[0].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[0].tableColumns[i].Name,
            field: this.Columns[0].tableColumns[i].Name,

            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
      if (this.Columns[1] != undefined) {
        for (let i = 1; i < this.Columns[1].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[1].tableColumns[i].Name,
            field: this.Columns[1].tableColumns[i].Name,

            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
      if (this.Columns[2] != undefined) {
        for (let i = 1; i < this.Columns[2].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[2].tableColumns[i].Name,
            field: this.Columns[2].tableColumns[i].Name,

            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
      if (this.Columns[3] != undefined) {
        for (let i = 1; i < this.Columns[3].tableColumns.length; i++) {
          this.columnDefsSample.push({
            headerName: this.Columns[3].tableColumns[i].Name,
            field: this.Columns[3].tableColumns[i].Name,

            width: 180,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            comparator: this.smartDateComparator,
          });
        }
      }
    }
    this.rowDatasample = [];
  }

  CloseMoadl() {
    this.modalService.dismissAll();
  }
  GenerateCstomReport(content) {
    let check_report_par = false;
    for (let i = 0; i < this.Columns.length; i++) {
      if (this.Columns[i].tableColumns.length > 1) {
        check_report_par = true;
      }
    }
    if (check_report_par == false) {
      Swal.fire({ text: "Please select atleast one parameteres !" });
      return false;
    }
    if (this.Columns[0].tableColumns.length! > 0) {
      this.modalService
        .open(content, { ariaLabelledBy: "modal-basic-title" })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          },
        );
    } else {
      Swal.fire({ text: "Please Select atleast one parameter" });
      return false;
    }
    this.addRetportTypeText = $("#GetReporttypeText option:selected").text();
  }

  omitSpecialChar(event) {
    const keyPressed = String.fromCharCode(event.keyCode);
    const verifyKeyPressed = /^[a-zA-Z0-9\' \u00C0-\u00FF]*$/.test(keyPressed);
    return verifyKeyPressed === true;
  }
  submitSavedReport() {
    if (
      this.reportname == "" ||
      this.reportname == undefined ||
      this.reportname.trim() == ""
    ) {
      Swal.fire({ text: "Please Enter Report Name" });
      return false;
    }
    this.EquipmentIds = [];
    this.count = 0;
    this.customReportRequestJson = {
      reportType: Number(this.reportCatageryType),
      reportTimeType: Number(this.reportTimeType),
      reportName: this.addRetportTypeText + " - " + this.reportname,
      groupByType: this.groupByID,
      columns: this.Columns,
    };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.saveReportSetting,
        this.customReportRequestJson,
      )
      .subscribe(
        (res) => {
          let GetRport = res;
          if (res.code === 1004) {
            Swal.fire({
              text: GetRport.status,
              icon: "success",
            });
            this.modalService.dismissAll();
            this.selectedReportType = "0";
            this.Header1 = false;
            this.Header2 = false;
            this.Header3 = false;
            this.Header4 = false;
            this.Header5 = false;
            this.Header6 = false;
            this.Header7 = false;
            this.Header8 = false;
            this.Header9 = false;
            this.Header10 = false;
            this.Header11 = false;
            this.Switch = false;
            this.hideCircleClustorDropdown = false;
            this.EquipmentDropdown = false;
            this.Columns = [];
            this.selectedItems = [];
            $(".rptype").addClass("rptype");

            this.fetchSavedRepoprt();
          } else {
            Swal.fire({
              text: GetRport.status,
              icon: "warning",
            });
          }
        },
        (error) => {
          console.error(error);
        },
      );
    this.reportname = "";
  }
  fetchSavedRepoprt() {
    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi + this.apiUrl.getEquipments,
        {},
      )
      .subscribe(
        (res) => {
          this.getSavedReports = res.response;
          this.editTableRow = res.response;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  selectedSavedReportType;
  selectedSavedReportTimeType;
  selectedSavedReportID;
  selectedReportName;
  SavedReportChange(ev) {
    if (!ev) {
      this.savedReportSelected = false;
      return;
    }
    this.savedReportSelected = true;
    this.selectedSavedReportId = ev.reportid;
    this.showWeeklyDD = false;
    this.showMonthlyDD = false;
    this.showdateTimePicker = false;
    this.selectedStartMonth = undefined;
    this.selectedWeek = undefined;
    this.GetSiteIdDetails = "";
    this.selectedTimeType = undefined;
    this.selectedDateRange = "";
    this.selectedSavedReport = this.getSavedReports.find((element) => {
      return element.reportid == this.selectedSavedReportID;
    });
    this.selectionParams = { ...this.selectedSavedReport };
    this.selectedReportName = this.selectedSavedReport.reportname;

    this.selectedSavedReportType = this.selectedSavedReport.reporttype;
    this.showtimeType = this.selectedSavedReportType == 2 ? true : false;
    this.showdateTimePicker = this.selectedSavedReportType != 2 ? true : false;
    this.mandatorySite =
      this.selectedSavedReportType == 2 || this.selectedSavedReportType == 5;
    this.mandatoryDate =
      this.selectedSavedReportType == 2 || this.selectedSavedReportType == 5;

    this.selectedSavedReportTimeType = this.selectedSavedReport.reporttimetype;
    const groupByType = this.selectedSavedReport.groupbytype;
    this.selectedCluster = "";
    this.selectedRegion = "";
    this.selectedSitIDItems = undefined;
    this.Acmeter = false;
    this.Dcmeter = false;
    this.powerPlant = false;
    this.selectedPowerPlant = undefined;
    this.selectedController = undefined;
    this.selectedGeneratorController = undefined;
    this.selectedRectifierController = undefined;
    this.selectedBatteryController = undefined;
    this.selectedTenant = undefined;
    this.AcmeterValues = [];
    this.DcmeterValues = [];
    this.powerPlantValues = "";
    this.dcmeterparams = false;
    this.scheduleBtnEnbDsb = true;
    this.fromDateVal = "From Date";
    this.selectedDateRange = "";
    this.selectedStartMonth = undefined;
    this.EnableSheduleReport = false;
    $("#saveEditScheduleName").val("");
    this.scheduleRepName = "";
    this.selectedgetEmailClass = [];
    $("._fd").val("");

    this.FromDate = undefined;
    this.ToDate = undefined;
    this.SiteDropdown = true;
    this.FromDateHide = false;
    this.showClusterDropDown = false;
    this.showRegionDropDown = false;
    this.ToDateHide = false;
    if (this.selectedSavedReportType == 4) {
      this.showdateTimePicker = false;
    } else {
      this.showdateTimePicker = true;
    }
    this.ClustorZoneDropdown = false;
    this.GenerateClearEnable = true;
    this.SelectedClustorZone = "";
    if (groupByType == -3) {
      if (this.selectedSavedReport.reporttimetype == 1) {
        this.SiteDropdown = true;
        this.FromDateHide = false;
        this.ToDateHide = false;
        this.showdateTimePicker = true;
        this.ScheduleEnable = false;
        this.showMonthlyDD = false;
      }
      if (this.selectedSavedReport.reporttimetype == 2) {
        // Monthly
        this.SiteDropdown = true;
        this.FromDateHide = false;
        this.ToDateHide = false;
        this.showdateTimePicker = false;
        this.ScheduleEnable = false;
        this.showMonthlyDD = true;
      }
    }

    if (groupByType == -2) {
      //cluster
      if (this.selectedSavedReport.reporttimetype == 1) {
        this.showClusterDropDown = true;
        this.FromDateHide = false;
        this.ToDateHide = false;
        this.showdateTimePicker = true;
        this.ScheduleEnable = true;
        this.fromDateVal = "From Date";
      }
      if (this.selectedSavedReport.reporttimetype == 2) {
        this.showClusterDropDown = true;
        this.showMonthlyDD = true;
        this.showdateTimePicker = false;
        this.ScheduleEnable = false;
        this.fromDateVal = "From Date";
      }
    }
    if (groupByType == -1) {
      //region
      if (this.selectedSavedReport.reporttimetype == 1) {
        this.showRegionDropDown = true;
        this.FromDateHide = false;
        this.ToDateHide = false;
        this.showdateTimePicker = true;
        this.ScheduleEnable = true;
        this.fromDateVal = "From Date";
      }
      if (this.selectedSavedReport.reporttimetype == 2) {
        this.showRegionDropDown = true;
        this.ScheduleEnable = false;
        this.fromDateVal = "From Date";
      }
    }
  }
  onMonthSelection(event) {
    this.selectedStartMonth = event.id;
    let selectedMonthRange = event.id.split("~");
    this.FromDate = "";
    this.ToDate = "";
    this.selectedWeek = undefined;
    const formattedFromDate = selectedMonthRange[0];
    this.FromDate = formattedFromDate;
    const formattedtoDate = selectedMonthRange[1];
    this.ToDate = formattedtoDate;
  }

  onweekSelection(event) {
    this.selectedWeek = event.id;
    let selectedWeekRange = event.id.split("~");
    this.FromDate = "";
    this.ToDate = "";
    this.selectedStartMonth = undefined;

    const formattedFromDate = selectedWeekRange[0];
    this.FromDate = formattedFromDate;
    const formattedtoDate = selectedWeekRange[1];
    this.ToDate = formattedtoDate;
  }

  getWeeklyData(startDayOfWeek) {
    function getWeekDates(
      startDate: Date,
      startDayOfWeek: number,
    ): { startDate: Date; endDate: Date } {
      const startOfWeek = new Date(startDate);
      const day = startOfWeek.getDay();
      const diff = (day < startDayOfWeek ? 7 : 0) + day - startDayOfWeek;
      startOfWeek.setDate(startOfWeek.getDate() - diff);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      return { startDate: startOfWeek, endDate: endOfWeek };
    }
    let weekNumber = 0;
    function getWeekNumber(date: Date): number {
      const start = new Date(date.getFullYear(), 0, 1);
      const diff = date.getTime() - start.getTime();
      const oneWeek = 1000 * 60 * 60 * 24 * 7;
      weekNumber + 1;
      return Math.ceil(diff / oneWeek + weekNumber);
    }

    const currentDate = new Date();
    const { startDate: currentWeekStart } = getWeekDates(
      currentDate,
      startDayOfWeek,
    );

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(currentDate.getFullYear() - 1);
    let weekStart = currentWeekStart;

    while (weekStart >= oneYearAgo) {
      const { startDate, endDate } = getWeekDates(weekStart, startDayOfWeek);

      const fromDate = `${("0" + startDate.getDate()).slice(-2)}-${(
        "0" +
        (startDate.getMonth() + 1)
      ).slice(-2)}-${startDate.getFullYear()} 00:00:00`;
      const toDate = `${("0" + endDate.getDate()).slice(-2)}-${(
        "0" +
        (endDate.getMonth() + 1)
      ).slice(-2)}-${endDate.getFullYear()} 23:59:59`;

      const weekNumber = getWeekNumber(weekStart);
      const finalWeek = `Week ${weekNumber}, ${startDate.getFullYear()}`;

      this.weekarr.push({
        id: fromDate + "~" + toDate,
        week: finalWeek,
        weekStartDate: startDate,
      });

      weekStart.setDate(weekStart.getDate() - 7);
    }

    this.weekarr.sort(
      (a, b) => b.weekStartDate.getTime() - a.weekStartDate.getTime(),
    );
  }

  getMonthlyData() {
    let d = new Date();
    this.montharr = [];

    function getMonthDates(
      year: number,
      month: number,
    ): { startDate: Date; endDate: Date } {
      const startOfMonth = new Date(year, month, 1);
      const endOfMonth = new Date(year, month + 1, 0);
      return { startDate: startOfMonth, endDate: endOfMonth };
    }

    const currentYear = d.getFullYear();
    const currentMonth = d.getMonth();

    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(currentYear - 1);

    let monthYear = { year: currentYear, month: currentMonth };

    const getMonthName = (date: Date) =>
      new Intl.DateTimeFormat("en-US", { month: "long" }).format(date);

    while (
      monthYear.year > oneYearAgo.getFullYear() ||
      (monthYear.year === oneYearAgo.getFullYear() &&
        monthYear.month >= oneYearAgo.getMonth())
    ) {
      const { startDate, endDate } = getMonthDates(
        monthYear.year,
        monthYear.month,
      );

      const fromDate = `${("0" + startDate.getDate()).slice(-2)}-${(
        "0" +
        (startDate.getMonth() + 1)
      ).slice(-2)}-${startDate.getFullYear()} 00:00:00`;

      const toDate = `${("0" + endDate.getDate()).slice(-2)}-${(
        "0" +
        (endDate.getMonth() + 1)
      ).slice(-2)}-${endDate.getFullYear()} 23:59:59`;

      const monthName = `${getMonthName(
        startDate,
      )}, ${startDate.getFullYear()}`;
      const finalMonth = `Month ${("0" + (startDate.getMonth() + 1)).slice(
        -2,
      )}, ${startDate.getFullYear()}`;

      this.montharr.push({
        id: fromDate + "~" + toDate,
        month: finalMonth,
        monthName: monthName,
        monthStartDate: startDate,
      });

      if (monthYear.month === 0) {
        monthYear.month = 11;
        monthYear.year -= 1;
      } else {
        monthYear.month -= 1;
      }
    }

    this.montharr.sort(
      (a, b) => b.monthStartDate.getTime() - a.monthStartDate.getTime(),
    );
  }
  changeOfClusterZoneFun() {
    if (this.SelectedClustorZone.length > 0) {
      this.scheduleBtnEnbDsb = false;
    } else {
      this.scheduleBtnEnbDsb = true;
    }
  }
  getFirstAndLastDayOfMonth(year, month) {
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    return {
      firstDay,
      lastDay,
    };
  }
  showAlert(message: string): boolean {
    Swal.fire({ text: message });
    return false;
  }
  generateSavedReport() {
    this.selectedCheckbox.length = 0;
    this.isDataAvailableRepchart = false;

    this.axisX = [];
    this.axisY = [];
    this.seriesData = [];

    this.SiteIdsDisplay = true;
    if (
      this.selectedSavedReport == "" ||
      this.selectedSavedReport == undefined
    ) {
      Swal.fire({ text: "Please Select Report" });
      return false;
    }
    if (this.selectedSavedReportType == 2) {
      if (this.selectedTimeType == "" || this.selectedTimeType == undefined) {
        Swal.fire({ text: "Please Select Time Type" });
        return false;
      }
    }
    if (this.selectedSavedReportType == 5) {
      if (!this.FromDate && !this.ToDate) {
        Swal.fire({ text: "Please Select Date Range" });
        return false;
      }
    }

    if (
      (this.selectedSavedReport.groupbytype == -3 &&
        this.selectedSavedReportType != 3) ||
      this.selectedSavedReportType == 5
    ) {
      if (
        this.selectedSitIDItems == "" ||
        this.selectedSitIDItems == undefined
      ) {
        Swal.fire({ text: "Please Select Site" });
        return false;
      }
    }

    if (
      this.selectedSavedReport.groupbytype == -2 &&
      this.selectedSavedReportType != 3
    ) {
      if (this.selectedCluster == "" || this.selectedCluster == undefined) {
        Swal.fire({ text: "Please Select Cluster" });
        return false;
      }
    }
    if (
      this.selectedSavedReport.groupbytype == -1 &&
      this.selectedSavedReportType != 3
    ) {
      if (this.selectedRegion == "" || this.selectedRegion == undefined) {
        Swal.fire({ text: "Please Select Region" });
        return false;
      }
    }

    if (this.selectedTimeType == 1 && this.selectedSavedReportType != 4) {
      if (!this.FromDate && !this.ToDate) {
        Swal.fire({ text: "Please select Date Range" });
        return false;
      }
    }
    if (this.selectedTimeType == 2) {
      if (
        this.selectedStartMonth == "" ||
        this.selectedStartMonth == undefined
      ) {
        Swal.fire({ text: "Please select  month" });
        return false;
      }
    }
    if (this.selectedTimeType == 3) {
      if (this.selectedWeek == "" || this.selectedWeek == undefined) {
        Swal.fire({ text: "Please select Week" });
        return false;
      }
    }

    if (this.selectionParams.tenantfilter == 2 && !this.selectedTenant) {
      return this.showAlert("Please select Tenent");
    } else if (
      this.selectionParams.generatorControllerfilter == 2 &&
      !this.selectedGeneratorController
    ) {
      return this.showAlert("Please select Generator controller");
    } else if (
      this.selectionParams.rectifierControllerfilter == 2 &&
      !this.selectedRectifierController
    ) {
      return this.showAlert("Please select Rectifier controller");
    } else if (
      this.selectionParams.batteryControllerfilter == 2 &&
      !this.selectedBatteryController
    ) {
      return this.showAlert("Please select Battery controller");
    } else if (this.selectionParams.PPFilter == 2 && !this.selectedPowerPlant) {
      return this.showAlert("Please select Power Plant");
    }
    if (this.FromDate) {
      this.FromToDateHistory = true;
    } else {
      this.FromToDateHistory = false;
    }
    if (this.pageIndex == 0) {
      this.showGridLoader = true;
    }
    this.MonthHistory = false;
    this.RequestGenerateData = {
      reportId: this.selectedSavedReportID?.toString(),
      ReportName: this.selectedReportName,
      reportType: this.selectedSavedReportType,
      pageIndex: this.pageIndex,
      regionID: this.selectedRegion?.toString().replace(/[\[\]']+/g, '"'),
      zoneID: "",
      clusterID: this.selectedCluster?.toString().replace(/[\[\]']+/g, '"'),
      siteTypeID: "",
      siteID:
        this.selectedSitIDItems != undefined
          ? this.selectedSitIDItems?.toString().replace(/[\[\]']+/g, '"')
          : "",
      fromDateTime: this.FromDate,
      toDateTime: this.ToDate,
      dateTimeFormat: "%d-%m-%Y",
      recordsPerPage: this.recordsPerRequest,
      timeType: this.selectedTimeType ? this.selectedTimeType?.toString() : "",
      equipmentType: "",
      equipmentId: "",
      reportCategoryID: "4",
      controllerID: this.selectedController
        ? this.selectedController?.toString().replace(/[\[\]']+/g, '"')
        : "",
      genControllerID: this.selectedGeneratorController
        ? this.selectedGeneratorController?.toString().replace(/[\[\]']+/g, '"')
        : "",
      recControllerID: this.selectedRectifierController
        ? this.selectedRectifierController?.toString().replace(/[\[\]']+/g, '"')
        : "",
      batControllerID: this.selectedBatteryController
        ? this.selectedBatteryController?.toString().replace(/[\[\]']+/g, '"')
        : "",
      powerPlantID: this.selectedPowerPlant
        ? this.selectedPowerPlant?.toString().replace(/[\[\]']+/g, '"')
        : "",
      tenantID: this.selectedTenant
        ? this.selectedTenant?.toString().replace(/[\[\]']+/g, '"')
        : "",
      toEmail: "",
      tocMail: "",
      message: "",
      jsonconfig: "",
      scheduleReportTitle: "",
    };

    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi + this.apiUrl.getReportdatas,
        this.RequestGenerateData,
      )
      .subscribe(
        (res) => {
          if (res.code == 200) {
            if (this.pageIndex == 0) {
              this.rowData = [];
              this.gridData1 = [];
              this.gridData = [];
            }
            this.disableExport = false;
            this.showGridLoader = false;

            let colHeaders = res.response[0];

            let rowDatas = res.response;
            this.headers = rowDatas[0];
            if (this.pageIndex == 0) {
              this.columnDefs = this.getColumns(rowDatas[0]);
            }
            this.Savedrep = this.selectedSavedReportTimeType;
            const frm_time = this.FromDate;
            const end_time = this.ToDate;
            this.frm = frm_time;
            this.end = end_time;
            this.globals.customFromDate = this.FromDate;
            this.globals.customToDate = this.ToDate;
            $("#tab-selectbyid2").show();
            this.tabset.select("tab-selectbyid2");
            this.SavedrepId = this.selectedSitIDItems;

            this.SummaryDetails = true;

            this.gridData1 = [];
            this.gridData1 = rowDatas;
            if (this.gridData1.length < this.recordsPerRequest) {
              this.disablelastbutton = true;
            } else {
              this.disablelastbutton = false;
            }

            for (let i = 0; i < this.gridData1.length; i++) {
              this.gridData.push(this.gridData1[i]);
            }
            if (this.gridData && this.gridData.length > 0) {
              this.disableExport = false;
              this.createRowData();
            } else {
              this.rowData = [];
              this.disableExport = true;
            }

            if (
              this.gridData.length == 0 ||
              this.gridData == undefined ||
              this.gridData == null
            ) {
              Swal.fire({ text: "No Records Found !" });
              this.showGridLoader = false;
              return false;
            }

            this.gridApi.setRowData(this.rowData);
          } else {
            this.showGridLoader = false;
            Swal.fire({ text: res.status });
            return false;
          }
        },
        (error) => {
          this.showGridLoader = false;
          console.error(error);
        },
      );
  }

  ngAfterViewChecked() {
    $("span.ag-paging-page-summary-panel").addClass("remi");
  }

  createRowData() {
    this.rowData = this.gridData;
  }

  onPageSizeChanged() {
    // const value = (<HTMLInputElement>document.getElementById("page-size"))?.value;
    this.gridApi.paginationSetPageSize(Number(this.gridRecordSize));
  }
  onReportPageSizeChanged() {
    this.gridData = [];
    this.gridData1 = [];
    this.rowData = [];
    this.pageIndex = 0;
    this.showGridLoader = true;
    this.recordsPerRequest = this.gridRecordSize;
    this.generateSavedReport();
    this.gridApi.paginationSetPageSize(this.gridRecordSize);
  }
  calculateRowCount() {
    this.recordSize = this.gridApi.paginationGetPageSize();
    this.pageNumber = this.gridApi.paginationGetCurrentPage();
    if (this.gridOptions.api && this.rowData) {
      const model = this.gridOptions.api.getModel();
    }
  }

  onGridPaginationChanged() {
    if (this.gridApi) {
      this.lastPageFound = this.gridApi.paginationIsLastPageFound();
      this.PageSize = this.gridApi.paginationGetPageSize();
      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.totalPage = this.gridApi.paginationGetTotalPages();
      this.totalRowCount = this.gridApi.getDisplayedRowCount();
      this.disablePrevBtn = this.currentPage == 1 ? true : false;
      this.disableNextBtn = this.currentPage === this.totalPage ? true : false;
    }
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastPageFound = this.gridApi.paginationIsLastPageFound();
      this.PageSize = this.gridApi.paginationGetPageSize();
      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.totalPage = this.gridApi.paginationGetTotalPages();
      this.totalRowCount = this.gridApi.getDisplayedRowCount();
      this.disablePrevBtn = this.currentPage == 1 ? true : false;
    }
  }
  fetchSites() {
    const siteRequest = {
      fmID: 10000,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.getSitedetails = resp.response[0].Data;
          this.getSitedetails.map((i) => {
            i.siteId_Name = i.SiteCode + " | " + i.SiteName;
            return i;
          });
        },
        (error) => {
          console.error(error);
        },
      );
  }

  private tryParseDateTime(str: string): number | null {
    if (!str) return null;
    const months: { [key: string]: number } = {
      January: 0,
      Jan: 0,
      February: 1,
      Feb: 1,
      March: 2,
      Mar: 2,
      April: 3,
      Apr: 3,
      May: 4,
      June: 5,
      Jun: 5,
      July: 6,
      Jul: 6,
      August: 7,
      Aug: 7,
      September: 8,
      Sep: 8,
      Sept: 8,
      October: 9,
      Oct: 9,
      November: 10,
      Nov: 10,
      December: 11,
      Dec: 11,
    };
    const named = str.match(
      /^(\d{1,2})[\/\-]([A-Za-z]+)[\/\-](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i,
    );
    if (named) {
      const [, day, mon, year, h = "0", m = "0", s = "0", ampm] = named;
      const cap = mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
      if (months[cap] !== undefined) {
        let hr = parseInt(h, 10);
        if (ampm?.toUpperCase() === "PM" && hr < 12) hr += 12;
        if (ampm?.toUpperCase() === "AM" && hr === 12) hr = 0;
        return new Date(+year, months[cap], +day, hr, +m, +s).getTime();
      }
    }
    const namedFirst = str.match(
      /^([A-Za-z]+)[\/\-](\d{1,2})[\/\-](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i,
    );
    if (namedFirst) {
      const [, mon, day, year, h = "0", m = "0", s = "0", ampm] = namedFirst;
      const cap = mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
      if (months[cap] !== undefined) {
        let hr = parseInt(h, 10);
        if (ampm?.toUpperCase() === "PM" && hr < 12) hr += 12;
        if (ampm?.toUpperCase() === "AM" && hr === 12) hr = 0;
        return new Date(+year, months[cap], +day, hr, +m, +s).getTime();
      }
    }
    const yearNamed = str.match(
      /^(\d{4})[\/\-]([A-Za-z]+)[\/\-](\d{1,2})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i,
    );
    if (yearNamed) {
      const [, year, mon, day, h = "0", m = "0", s = "0", ampm] = yearNamed;
      const cap = mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
      if (months[cap] !== undefined) {
        let hr = parseInt(h, 10);
        if (ampm?.toUpperCase() === "PM" && hr < 12) hr += 12;
        if (ampm?.toUpperCase() === "AM" && hr === 12) hr = 0;
        return new Date(+year, months[cap], +day, hr, +m, +s).getTime();
      }
    }
    const iso = str.match(
      /^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i,
    );
    if (iso) {
      const [, year, month, day, h = "0", m = "0", s = "0", ampm] = iso;
      let hr = parseInt(h, 10);
      if (ampm?.toUpperCase() === "PM" && hr < 12) hr += 12;
      if (ampm?.toUpperCase() === "AM" && hr === 12) hr = 0;
      return new Date(+year, +month - 1, +day, hr, +m, +s).getTime();
    }
    const numeric = str.match(
      /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i,
    );
    if (numeric) {
      const [, part1, part2, year, h = "0", m = "0", s = "0", ampm] = numeric;
      let hr = parseInt(h, 10);
      if (ampm?.toUpperCase() === "PM" && hr < 12) hr += 12;
      if (ampm?.toUpperCase() === "AM" && hr === 12) hr = 0;
      const p1 = parseInt(part1, 10);
      const p2 = parseInt(part2, 10);
      let month: number, day: number;
      if (p1 > 12) {
        day = p1;
        month = p2;
      } else if (p2 > 12) {
        month = p1;
        day = p2;
      } else {
        try {
          const stored = localStorage.getItem("userSettings");
          const fmt = stored ? JSON.parse(stored).userDateFormat || "" : "";
          if (fmt.startsWith("MM") || fmt.startsWith("mm")) {
            month = p1;
            day = p2;
          } else {
            day = p1;
            month = p2;
          }
        } catch {
          day = p1;
          month = p2;
        }
      }
      return new Date(+year, month - 1, day, hr, +m, +s).getTime();
    }
    return null;
  }

  private readonly smartDateComparator = (
    valueA: string,
    valueB: string,
  ): number => {
    const tsA = this.tryParseDateTime(valueA);
    const tsB = this.tryParseDateTime(valueB);
    if (tsA !== null && tsB !== null) return tsA - tsB;
    if (valueA == null && valueB == null) return 0;
    if (valueA == null) return -1;
    if (valueB == null) return 1;
    return String(valueA).localeCompare(String(valueB));
  };

  getColumns(header: any) {
    let columnDefinitions = [];
    for (let key in header) {
      if (header.hasOwnProperty(key)) {
        let value = header[key];

        let isNumber = !isNaN(value) && value !== "" && value !== null;

        columnDefinitions.push({
          headerName: key,
          field: key,
          filter: isNumber ? "agNumberColumnFilter" : "agTextColumnFilter",
          comparator: isNumber ? undefined : this.smartDateComparator,
          chartDataType: isNumber ? "series" : "category",
        });
      }
    }
    return columnDefinitions;
  }

  generateColumns(data, header) {
    let columnDefinitions = [];
    let heading = "";
    let id = "";
    let rowGroup = "";
    let groupingsMap: { [key: string]: any } = {};
    let singleHeaderSet = new Set();

    header.forEach((element) => {
      let heading = element.name;

      if (element.grouping === "") {
        if (!singleHeaderSet.has(heading)) {
          let mappedColumn = {
            headerName: heading,
            field: heading,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
          };
          columnDefinitions.push(mappedColumn);
          singleHeaderSet.add(heading);
        }
      } else {
        let group = element.grouping;

        let existingGroup = groupingsMap[group];
        if (!existingGroup) {
          existingGroup = {
            headerName: group,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
            children: [],
          };
          groupingsMap[group] = existingGroup;
          columnDefinitions.push(existingGroup);
        }

        if (heading !== group) {
          let childElement = {
            headerName: heading,
            field: heading,
            chartDataType: "series",
            enablePivot: true,
            filter: "agTextColumnFilter",
          };
          existingGroup.children.push(childElement);
        }
      }
    });

    return columnDefinitions;
  }

  fetchTabVal(event) {
    // this.clearReportsInputValue();
    this.pageIndex = 0;
    if (event.nextId == "tab-selectbyid5") {
      this.exportId = 0;
      this.getAllExportedReportsData();
    }

    this.EnableSheduleReport = false;
    if (event.nextId == "tab-selectbyid1") {
    }
    if (
      event.nextId == "tab-selectbyid1" ||
      event.nextId == "tab-selectbyid3" ||
      "tab-selectbyid4"
    ) {
      this.SummaryDetails = false;
      this.headers = [];
      this.rowData = [];
    }
    if (
      event.nextId == "tab-selectbyid1" ||
      event.nextId == "tab-selectbyid3" ||
      event.nextId == "tab-selectbyid4" ||
      event.nextId == "tab-selectbyid5"
    ) {
      $("#tab-selectbyid2").hide();
    } else {
      $("#tab-selectbyid2").show();
    }
  }

  datetimeformatee(params) {
    if (
      params.value != "" &&
      this.dateTimeFormat != undefined &&
      params.value != undefined
    ) {
      var date = new Date(params.value);
      if (this.dateTimeFormat.includes("tt")) {
        this.dateTimeFormat = this.dateTimeFormat.replace("tt", "a");
      }
      if (this.dateTimeFormat.includes("Decimal")) {
        this.dateTimeFormat = this.dateTimeFormat.replace(
          "HH:mm(Decimal)",
          "HH:mm",
        );
      }
      var fomateddate = this.datePipe.transform(date, this.dateTimeFormat);
      return fomateddate;
    }
  }
  clearReportsInputValue() {
    this.selectedDateRange = "";
    this.selectedStartMonth = undefined;
    this.selectedWeek = undefined;
    this.selectedSitIDItems = undefined;
    this.selectedSavedReport = undefined;
    this.selectedSavedReportID = undefined;
    this.FromDate = undefined;
    this.ToDate = undefined;
    ((this.selectedController = ""),
      (this.selectedPowerPlant = ""),
      (this.selectedTenant = ""),
      (this.headers = []));
    this.rowData = [];
    this.selectedGeneratorController = undefined;
    this.selectedRectifierController = undefined;
    this.selectedBatteryController = undefined;
    this.slectedacmeter = undefined;
    this.selectedDcmeter = undefined;
    this.selectedStartMonth = "";
    this.SelectedClustorZone = "";
    this.ScheduleEnable = false;
    this.EnableSheduleReport = false;
    $("#saveEditScheduleName").val("");
    this.scheduleRepName = "";
    this.selectedgetEmailClass = [];
    $("._fd").val("");
    $(".FilterSpan").html("");
    this.getmailIdvalues = [];
    $("#owldateRange").val("");
  }
  customCsv() {
    var text =
      "SiteId | Site Name  " +
      this.GetSiteIdDetails +
      "   From: " +
      this.frm +
      "  To: " +
      this.end;
    return text;
  }
  reportExport(id) {
    this.showGridLoader = true;

    let exportRequest = { ...this.RequestGenerateData, ExportType: id };
    this.http
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.exportReportsUrl,
        exportRequest,
      )
      .subscribe(
        (res) => {
          const resp = res;
          if (resp.code == 200) {
            this.exportedId = resp.response[0].exportid;
            this.downloadExportedReportsData(this.exportedId);
          }
        },
        (error) => {
          Swal.close();
          console.error(error);
          this.showGridLoader = false;
        },
      );
  }

  downloadExportedReportsData(id) {
    // const apiUrl = `${this.urlAuthentication.reportsApi}${this.apiUrl.downloadReports}?Exportid=${id}`;
    const apiUrl = `${this.urlAuthentication.reportsApi}${this.apiUrl.downloadReports}`;
    const authToken = sessionStorage.getItem("invUIToken");

    // fetch(apiUrl, {
    //   method: "GET",
    //   headers: {
    //     Accept: "application/zip",
    //     Authorization: `${authToken}`,
    //   },
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/zip",
        Authorization: `${authToken}`,
      },
      body: JSON.stringify({
        Exportid: id.toString(),
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const contentDisposition = response.headers.get("content-disposition");
        let filename = "report.zip";

        if (contentDisposition && contentDisposition.includes("filename=")) {
          const matches = contentDisposition.match(
            /filename\*?=['"]?(?:UTF-8'')?([^'";]+)['"]?/,
          );
          if (matches && matches[1]) {
            filename = decodeURIComponent(matches[1]);
          }
        }

        return response.blob().then((blob) => ({ blob, filename }));
      })
      .then(({ blob, filename }) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.showGridLoader = false;
      })
      .catch((error) => {
        this.showGridLoader = false;
        console.error("Error:", error);
      });
  }

  exportedReportsData() {
    const payload = {
      ReportCategoryID: "4",
      Exportid: "0",
    };
    this.http
      // .get(
      //   this.urlAuthentication.reportsApi +
      //     this.apiUrl.exportedReportsUrl +
      //     `?Exportid=${this.exportId}&ReportCategoryID=4`
      // )
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.exportedReportsUrl,
        payload,
      )
      .subscribe((res) => {
        let exportData = res.response;

        this.downloadReport(exportData[0]);
        this.getAllExportedReportsData();
      });
  }
  getAllExportedReportsData() {
    const payload = {
      ReportCategoryID: "4",
      Exportid: "0",
    };
    this.http
      // .get(
      //   this.urlAuthentication.reportsApi +
      //     this.apiUrl.exportedReportsUrl +
      //     `?Exportid=0&ReportCategoryID=4`
      // )
      .post(
        this.urlAuthentication.reportsApi + this.apiUrl.exportedReportsUrl,
        payload,
      )
      .subscribe((res) => {
        this.exportedReportslist = [];
        this.exportedReportslist = res.response;
      });
  }
  getRows(): ExcelRow[] {
    return [
      { cells: [] },

      {
        cells: [
          { data: { value: "", type: "String" } },
          {
            data: {
              value: this.selectedReportName
                ? `Report Name: ${this.selectedReportName}`
                : "",
              type: "String",
            },
            mergeAcross: 3,
            styleId: "headerStyle",
          },
        ],
      },

      {
        cells: [
          { data: { value: "", type: "String" } },
          {
            data: {
              value: this.GetSiteIdDetails ? `Site Name:` : "",
              type: "String",
            },
            styleId: "subHeaderStyle",
          },
          {
            data: {
              value: this.GetSiteIdDetails ? ` ${this.GetSiteIdDetails}` : "",
              type: "String",
            },
            mergeAcross: 2,
            styleId: "subHeaderStyle",
          },
        ],
      },

      {
        cells: [
          { data: { value: "", type: "String" } },
          {
            data: {
              value: this.globals.customFromDate ? `From Date:` : "",
              type: "String",
            },
            styleId: "subHeaderStyle",
          },

          {
            data: {
              value: this.globals.customFromDate,
              type: "String",
            },
            styleId: "subHeaderStyle",
          },
          {
            data: {
              value: this.globals.customToDate ? `To Date:` : "",
              type: "String",
            },
            styleId: "subHeaderStyle",
          },

          {
            data: {
              value: this.globals.customToDate,
              type: "String",
            },
            styleId: "subHeaderStyle",
          },
        ],
      },

      { cells: [] },
    ];
  }
  uiExportReport(id) {
    this.exportedId = 0;
    this.showGridLoader = true;
    let exportRequest = {
      ...this.RequestGenerateData,
      recordsPerPage: "50000",
      pageIndex: 0,
    };
    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi + this.apiUrl.getReportdatas,
        exportRequest,
      )
      .subscribe(
        (res) => {
          this.showGridLoader = false;
          if (res.code == 400) {
            this.showGridLoader = false;
            Swal.fire({ text: res.status, icon: "warning" });
            return false;
          }
          let rowDatas = res.response;
          if (
            !rowDatas ||
            rowDatas.length === 0 ||
            rowDatas === undefined ||
            rowDatas === null
          ) {
            this.showGridLoader = false;
            Swal.fire({ text: "No Records Found !" });
            return false;
          }

          let headers = rowDatas[0];
          const columnDefs = this.getColumns(headers);

          const tempDiv = document.createElement("div");
          tempDiv.style.display = "none";
          document.body.appendChild(tempDiv);

          const tempGridOptions: GridOptions = {
            columnDefs: columnDefs,
            rowData: rowDatas,
            defaultColDef: {
              sortable: true,
              filter: true,
              resizable: true,
            },
            suppressExcelExport: false,
            suppressCsvExport: false,
            excelStyles: this.excelStyles,
          };

          new Grid(tempDiv, tempGridOptions);

          setTimeout(() => {
            try {
              const getParams: () => ExcelExportParams = () => ({
                prependContent: this.getRows(),
                fileName: `${this.selectedReportName || "Report"}_${
                  new Date().toISOString().split("T")[0]
                }`,
                sheetName: `${this.selectedReportName}`,
              });
              if (id === 1) {
                tempGridOptions.api.exportDataAsExcel(getParams());
              } else if (id === 2) {
                const params = {
                  fileName: `${this.selectedReportName || "Report"}_${
                    new Date().toISOString().split("T")[0]
                  }`,
                  sheetName: `${this.selectedReportName}`,
                };
                tempGridOptions.api.exportDataAsCsv(params);
              }

              setTimeout(() => {
                document.body.removeChild(tempDiv);
              }, 1000);
            } catch (error) {
              console.error("Export error:", error);
              Swal.fire({
                text: "Export failed. Please try again.",
                icon: "error",
              });
            }
          }, 500);
        },
        (error) => {
          Swal.close();
          console.error(error);
          this.showGridLoader = false;
        },
      );
  }
  downloadReport(rep: any) {
    const link = document.createElement("a");
    link.href = rep.filePath;
    link.download = rep.reportname;
    link.click();
  }
  public onGridReady(datas) {
    this.gridApi = datas.api;
    this.onReportPageSizeChanged();
  }
  public onReady(datas) {
    this.gridApi = datas.api;
    this.onPageSizeChanged();
  }

  ngAfterViewInit() {
    $("#tab-selectbyid2").hide();
  }

  ngOnInit() {
    this.getWeeklyData(this.startOftheWeek);
    this.getMonthlyData();
    this.settings = {
      singleSelection: false,
      idField: "reportid",
      textField: "reportname",
      enableCheckAll: false,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      allowSearchFilter: true,
      limitSelection: 10,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 2,
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settings1 = {
      singleSelection: false,
      idField: "tnID",
      textField: "Name",
      enableCheckAll: false,
      selectAllText: "Chọn All",
      unSelectAllText: "Hủy chọn",
      allowSearchFilter: true,
      limitSelection: 4,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settings2 = {
      singleSelection: false,
      idField: "ID",
      textField: "Name",
      enableCheckAll: false,
      selectAllText: "Chọn All",
      unSelectAllText: "Hủy chọn",
      allowSearchFilter: true,
      limitSelection: 4,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.settings3 = {
      singleSelection: true,
      idField: "ID",
      textField: "Name",
      enableCheckAll: false,
      selectAllText: "Chọn All",
      unSelectAllText: "Hủy chọn",
      allowSearchFilter: true,
      limitSelection: 4,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 3,
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.setForm();
  }

  changeSite(e) {
    this.searchGeneratorController = [];
    this.GetSiteIdDetails = "";
    this.GetSiteIdDetails = e?.siteId_Name;
    this.slectedacmeter = undefined;
    this.selectedDcmeter = undefined;
    this.selectedPowerPlant = undefined;
    this.selectedController = undefined;
    this.selectedGeneratorController = undefined;
    this.selectedRectifierController = undefined;
    this.selectedBatteryController = undefined;
    this.selectedTenant = undefined;

    this.tenantList();
    this.powerplantList();

    this.rectControllerList();
    this.batControllerList();
    this.genControllerList();
  }

  getAcemeter(siteId) {
    this.http
      .get(
        this.urlAuthentication.itocUrl + this.apiUrl.AcmeterUrl + "/" + siteId,
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res);
          this.AcmeterValues = JSON.parse(getResp);
        },
        (error) => {
          console.error(error);
        },
      );
  }
  getDcemeter(siteId) {
    this.http
      .get(
        this.urlAuthentication.itocUrl + this.apiUrl.DCmeterUrl + "/" + siteId,
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res);
          this.DcmeterValues = JSON.parse(getResp);
        },
        (error) => {
          console.error(error);
        },
      );
  }
  getPowerPlants(siteId) {
    this.powerPlantValues = [];
    this.http
      .get(
        this.urlAuthentication.itocUrl +
          this.apiUrl.powerPlantUrl +
          "/" +
          siteId,
      )
      .subscribe(
        (res) => {
          const getResp: string = JSON.stringify(res);
          this.powerPlantValues = JSON.parse(getResp);
        },
        (error) => {
          console.error(error);
        },
      );
  }

  public setForm() {
    this.form = new FormGroup({
      name: new FormControl(this.EquipDropdown, Validators.required),
    });
    this.loadContent = true;
  }
  get f() {
    return this.form.controls;
  }
  public save() {}
  public onItemSelect(item: any) {
    this.Date = true;
    this.Switch = true;
    this.EquipmentTypes = item.reportid;
    this.EquipmentIds.push(item.reportid);
    const fullItem = this.EquipDropdown.find(
      (e: any) => e.reportid === item.reportid,
    );
    const reportType = fullItem?.systemdefined;

    if (this.removeIndex.length > 0) {
      for (let _v of this.removeIndex) {
        let m = this.EquipmentIds[_v];
        if (m !== item.reportid) {
          this.EquipmentIds.splice(_v, 1);
        }
      }
      this.removeIndex = [];
    }

    this.EquipmentIds = Array.from(new Set(this.EquipmentIds));

    this.count++;
    // this.getequip(
    //   item.reportid,
    //   item.reportname,
    //   this.reportCatageryType,
    // );
    this.getEquipColms(item.reportid, item.reportname, reportType);
  }

  public onDeSelect(item: any) {
    // Clean up Columns entry for this equipment
    this.Columns = this.Columns.filter(
      (col) => col.equipmentID != item.reportid,
    );

    // Track index for EquipmentIds cleanup on next onItemSelect
    for (let k = 0; k < this.EquipmentIds.length; k++) {
      if (this.EquipmentIds[k] == item.reportid) {
        this.removeIndex.push(k);
        break;
      }
    }

    // Find actual slot by name (index-based lookup is unreliable after re-selection)
    const equipNames = [
      this.EquipmentName2,
      this.EquipmentName3,
      this.EquipmentName4,
      this.EquipmentName5,
      this.EquipmentName6,
      this.EquipmentName7,
      this.EquipmentName8,
      this.EquipmentName9,
      this.EquipmentName10,
      this.EquipmentName11,
    ];
    const slotIndex = equipNames.indexOf(item.reportname);
    if (slotIndex >= 0) {
      this.removeItem(slotIndex);
    }

    if (this.selectedItems.length === 0) {
      this.Switch = false;
    }
  }

  public onDeSelectAll(items: any[]) {
    this.Header2 = false;
    this.Header3 = false;
    this.Header4 = false;
    this.Header5 = false;
    this.Header6 = false;
    this.Header7 = false;
    this.Header8 = false;
    this.Header9 = false;
    this.Header10 = false;
    this.Header11 = false;
    this.Columns = [];
    this.EquipmentIds = [];
    this.removeIndex = [];
    this.Switch = false;
  }

  removeItem(ids: number) {
    switch (ids) {
      case 0:
        this.Header2 = false;
        break;
      case 1:
        this.Header3 = false;
        break;
      case 2:
        this.Header4 = false;
        break;
      case 3:
        this.Header5 = false;
        break;
      case 4:
        this.Header6 = false;
        break;
      case 5:
        this.Header7 = false;
        break;
      case 6:
        this.Header8 = false;
        break;
      case 7:
        this.Header9 = false;
        break;
      case 8:
        this.Header10 = false;
        break;
      case 9:
        this.Header11 = false;
        break;
      default:
        console.log(`No header mapped for id: ${ids}`);
    }
  }

  date_diff_indays(dt1, dt2) {
    return Math.floor(
      (Date.UTC(dt2.year, dt2.month, dt2.day) -
        Date.UTC(dt1.year, dt1.month, dt1.day)) /
        (1000 * 60 * 60 * 24),
    );
  }
  inputFromDate() {
    this.afterFromDate = false;
  }
  inputToDate(date: NgbDate) {
    if (this.FromDate && this.ToDate) {
      this.ToDate = date;
      let StartDateDevice =
        this.FromDate.month +
        "/" +
        this.FromDate.day +
        "/" +
        this.FromDate.year;
      let EndDateDeviced =
        this.ToDate.month + "/" + this.ToDate.day + "/" + this.ToDate.year;
      if (Date.parse(EndDateDeviced) < Date.parse(StartDateDevice)) {
        Swal.fire({ text: "End date should be greater than Start date" });
        this.ToDate = "";
        return false;
      }
      const difference = Math.abs(
        this.date_diff_indays(this.FromDate, this.ToDate),
      );
      if (this.selectedSavedReport.split(",")[2] == 5) {
        if (difference > 30) {
          Swal.fire(
            "Please select the date which ranges between 1-30 days only",
          );
          return false;
        }
      }
      if (this.selectedSavedReport.split(",")[2] == 2) {
        if (difference >= 31) {
          Swal.fire({ text: "Max. 31 Days allowed" });
          setTimeout(function () {
            this.ToDate = "";
            $("._date ").val("");
          }, 500);
          return false;
        }
      } else {
        const stdate = new Date(
          this.FromDate.year,
          this.FromDate.month - 1,
          this.FromDate.day,
        );
        const endate = new Date(
          this.ToDate.year,
          this.ToDate.month - 1,
          this.ToDate.day,
        );
        this.startDt = this.datePipe.transform(stdate, "dd-MM-yyyy");
        this.endDt = this.datePipe.transform(endate, "dd-MM-yyyy");
        this.dateRange = this.startDt + " - " + this.endDt;
        this.startDt = this.startDt.concat(" 00:00:00");
        this.endDt = this.endDt.concat(" 23:59:59");
      }
    }
  }
  allparameters() {
    this.genChartPara = this.selectedCheckbox1;
    for (let i = 0; i < this.chartData.length; i++) {
      this.chartxparam.push(this.chartData[i].TRANSDATETIME);
    }
    let i;
    let j;
    let headerValArr: any[] = [];
    this.finalarr = [];
    for (i = 0; i < this.selectedCheckbox.length; i++) {
      const key = this.selectedCheckbox[i].id;
      const name = this.selectedCheckbox[i].name;
      const isDuration = this.selectedCheckbox[i].isDuration;
      headerValArr = [];
      for (j = 0; j < this.rowData.length; j++) {
        const data = this.rowData[j][key];
        headerValArr.push(data);
      }
      this.finalarr.push({
        headername: key,
        value: headerValArr,
        name: name,
        isDuration: isDuration,
      });
    }
    this.genrateChart(this.finalarr);
  }
  genrateChart(globalValue) {
    this.chartOptions = {
      chart: {
        borderColor: "#dddddd",
        borderWidth: 2,
        backgroundColor: "#ffffff",
        type: "spline",
        zoomType: "x",
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "    ",
        align: "  ",
      },
      subtitle: {
        text: "   ",
        align: "  ",
      },
      xAxis: [
        {
          min: 0,
          categories: this.chartxparam,
          crosshair: true,
        },
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              legend: {
                align: "center",
                verticalAlign: "bottom",
                layout: "horizontal",
              },
            },
          },
        ],
      },
      yAxis: [
        {
          legend: {
            enabled: true,
            layout: "horizontal",
            align: "center",
            x: 80,
            verticalAlign: "bottom",
            y: 5,
            floating: true,
          },
          labels: {
            formatter: function () {
              ((this.ts = this.value),
                (this.hs = this.ts / (3600 * 1000)),
                (this.ms = new Date(this.ts).getUTCMinutes()));
              this.sc = new Date(this.ts).getUTCSeconds();
              this.sc = this.sc < 10 ? "0" + this.sc : this.sc;
              this.ms = this.ms < 10 ? "0" + this.ms : this.ms;
              this.hs = this.hs < 10 ? "0" + this.hs : this.hs;
              if (this.hs > 1)
                return (
                  Math.floor(this.hs) +
                  ":" +
                  Math.floor(this.ms) +
                  ":" +
                  Math.floor(this.sc)
                );
              else return Math.floor(this.ms) + ":" + Math.floor(this.sc);
            },
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          title: {
            text: "Time Duration",
            style: {
              color: Highcharts.getOptions().colors[2],
            },
          },
        },
        {
          gridLineWidth: 2,
          title: {
            text: "    ",
            style: {
              color: Highcharts.getOptions().colors[3],
            },
          },
          labels: {
            format: "{value}",
            style: {
              color: Highcharts.getOptions().colors[4],
            },
          },
          opposite: true,
        },
      ],
      type: "datetime",
      tooltip: {
        shared: false,
        headerFormat: "<b>{this.series.name}</b><br>",
        formatter: function () {
          let str = this.series.name;
          this.seriesName = str.substr(0, str.lastIndexOf(" "));
          this.lastIndexVal = str.substring(str.lastIndexOf(" "));
          ((this.ts = Math.floor(this.y)), (this.sc = this.ts / 1000));
          this.ms = Math.floor(this.sc / 60);
          this.hs = Math.floor(this.ms / 60);
          this.days = Math.floor(this.hs / 24);
          this.hs = this.hs - this.days * 24;
          this.ms = this.ms - this.days * 24 * 60 - this.hs * 60;
          this.sc =
            this.sc -
            this.days * 24 * 60 * 60 -
            this.hs * 60 * 60 -
            this.ms * 60;
          if (this.series.name.includes("Hours")) {
            return (
              "<b>" +
              this.seriesName +
              " " +
              this.x +
              "</b><br/>" +
              this.days +
              " days " +
              this.hs +
              " hrs " +
              this.ms +
              " mins " +
              this.hs +
              " secs"
            );
          } else {
            return (
              "<b>" +
              this.seriesName +
              " " +
              this.x +
              "</b><br/>" +
              this.y +
              "<b>" +
              this.lastIndexVal +
              "<b>"
            );
          }
        },
      },
      series: this.seriesData,
    };
    this.seriesData.length = 0;
    this.selectedCity;
    this.Highcharts = Highcharts;
    let tt = [];
    let hourvalue = [];
    let hourvalue1 = "";
    let hourkey = "";
    let hourname = "";
    for (let j = 0; j < globalValue.length; j++) {
      hourvalue = globalValue[j].value;
      hourkey = globalValue[j].headername;
      hourname = globalValue[j].name;
      this.sec = [];
      if (globalValue[j].isDuration == "1") {
        hourvalue.forEach((element) => {
          if (element != undefined) {
            tt = element.split(":");
            this.sec.push((tt[0] * 3600 + tt[1] * 60 + tt[2] * 1) * 1000);
          }
        });
        this.seriesData = this.generateChartData(hourname, this.sec);
        this.SummaryDetails = false;
        this.isDataAvailableRepchart = true;
      } else if (globalValue[j].isDuration == "0") {
        hourvalue1 = JSON.stringify(hourvalue).replace(/"/g, "").trim();
        hourvalue1 = JSON.parse(hourvalue1);
        this.seriesData = this.generateChartData1(hourname, hourvalue1);
        this.SummaryDetails = false;
        this.isDataAvailableRepchart = true;
      }
    }
  }
  backToReport() {
    this.genChartPara = "";
    this.seriesData.length = 0;
    this.selectedCheckbox1 = "";
    this.seriesData = [];
    this.finalarr.length = 0;
    this.SummaryDetails = true;
    this.isDataAvailableRepchart = false;
    this.modalService.dismissAll();
  }
  generateChartData(hourkey, sec) {
    this.seriesData.push({
      name: hourkey,
      data: sec,
      yAxis: 0,
    });
    return this.seriesData;
  }
  generateChartData1(hourkey, hourvalue1) {
    this.seriesData.push({
      name: hourkey,
      data: hourvalue1,
      yAxis: 1,
    });
    return this.seriesData;
  }
  onChange1(chBox, event) {
    this.selectedCheckbox1 = "";
    this.selectedCheckbox1 = chBox.id;
  }
  onChange(chBox, event) {
    this.selectedCheckbox = [];
    var cbIdx = this.cbChecked.indexOf(chBox);
    if (event.target.checked) {
      if (cbIdx < 0) this.cbChecked.push(chBox);
    } else {
      if (cbIdx >= 0) this.cbChecked.splice(cbIdx, 1);
    }
    this.selectedCheckbox = this.cbChecked;
  }

  CircleClustorChange(event: any) {
    this.groupByID = event.target.value;

    if (event.target.value == "0") {
      this.EquipmentDropdown = false;
    } else {
      this.EquipmentDropdown = true;
    }
    this.selectedClustorCircleZone = event.target.value;
    this.Columns = [];
    this.selectedItems = [];
    this.Header1 = false;
    this.Header2 = false;
    this.Header3 = false;
    this.Header4 = false;
    this.Header5 = false;
    this.Header6 = false;
    this.Header7 = false;
    this.Header8 = false;
    this.Header9 = false;
    this.Header10 = false;
    this.Header11 = false;
    this.Switch = false;
    this.count = 0;
  }

  searchRegion;
  searchCluster;
  getRegionData() {
    const regionReq = {
      fmID: 10002,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, regionReq)
      .subscribe(
        (resp) => {
          this.searchRegion = [];
          let regionList = resp.response[0].Data;
          this.searchRegion = regionList.filter(
            (item) => item.RegionID && item.RegionName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
  }
  getClusterData() {
    const clusterReq = {
      fmID: 10001,
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, clusterReq)
      .subscribe(
        (resp) => {
          let clusterlist = resp.response[0].Data;
          this.searchCluster = clusterlist.filter(
            (item) => item.ClusterID && item.ClusterName,
          );
        },
        (error) => {
          console.error(error);
        },
      );
  }

  resetAll() {
    this.selectedCheckbox.length = 0;
  }

  onDateDetailedSelection(date) {
    this.selectedStartMonth = undefined;
    this.selectedWeek = undefined;
    let frmDate = date[0];
    let endDates = date[1];
    if (endDates == null) {
      Swal.fire({ text: "Please select date range" });
      $("#owldateRange").val("");
      return false;
    } else {
      let getFromHours = frmDate.getHours();
      let getFromMinutes = frmDate.getMinutes();
      let getFromSeconds = frmDate.getSeconds();
      if (getFromHours <= 9) {
        getFromHours = "0" + getFromHours;
      }
      if (getFromMinutes <= 9) {
        getFromMinutes = "0" + getFromMinutes;
      }
      if (getFromSeconds <= 9) {
        getFromSeconds = "0" + getFromSeconds;
      }
      this.finalFromTime =
        getFromHours + ":" + getFromMinutes + ":" + getFromSeconds;

      let getToHours = endDates.getHours();
      let getToMinutes = endDates.getMinutes();
      let getToSeconds = endDates.getSeconds();
      if (getToHours <= 9) {
        getToHours = "0" + getToHours;
      }
      if (getToMinutes <= 9) {
        getToMinutes = "0" + getToMinutes;
      }
      if (getToSeconds <= 9) {
        getToSeconds = "0" + getToSeconds;
      }
      this.finalToTime = "23" + ":" + "59" + ":" + "59";

      this.FromDate = new Date(
        frmDate.getFullYear(),
        frmDate.getMonth(),
        frmDate.getDate(),
      );
      this.ToDate = new Date(
        endDates.getFullYear(),
        endDates.getMonth(),
        endDates.getDate(),
      );
      if (!this.FromDate && !this.toDate) {
        this.FromDate = frmDate;
      } else if (this.FromDate && this.ToDate) {
        this.ToDate = date;
        const difference = Math.abs(
          this.date_diff_time_indays(frmDate, endDates),
        );

        if (difference >= 31 && this.selectedSavedReportType == 1) {
          Swal.fire({ text: "Max. 31 Days allowed" });
          $("#owldateRange").val("");
          this.FromDate = null;
          this.ToDate = null;
          $("#owldateRange").val("");
        } else {
          const stdate = new Date(
            frmDate.getFullYear(),
            frmDate.getMonth(),
            frmDate.getDate(),
          );
          const endate = new Date(
            endDates.getFullYear(),
            endDates.getMonth(),
            endDates.getDate(),
          );
          this.standardStartDate = stdate;
          this.standardEndDate = endate;
          this.startDt = this.datePipe.transform(stdate, "dd-MM-yyyy");
          this.endDt = this.datePipe.transform(endate, "dd-MM-yyyy");
          this.dateRange = this.startDt + " - " + this.endDt;
          this.FromDate = this.startDt.concat(" " + this.finalFromTime);
          this.ToDate = this.endDt.concat(" " + this.finalToTime);
        }
      } else {
        this.ToDate = null;
        this.FromDate = date;
        const stdate = new Date(
          this.FromDate.year,
          this.FromDate.month - 1,
          this.FromDate.day,
        );
        this.startDt = this.datePipe.transform(stdate, "dd-MM-yyyy");
        const endDate = this.startDt;
        this.dateRange = this.startDt + " - " + this.startDt;
        this.FromDate = this.startDt.concat(" " + this.finalFromTime);
        this.ToDate = endDate.concat(" " + this.finalToTime);
      }
    }
  }
  date_diff_time_indays(dt1, dt2) {
    const timeDiff = Math.abs(dt1.getTime() - dt2.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  }

  getEmailIds() {}

  keyUpFunction(event) {
    let storeValues: any;
    if (event.keyCode == 13) {
      let storedVal = event.target.value;
      storeValues = storedVal.split("\n");
      for (let i = 0; i <= storeValues.length - 2; i++) {
        this.unique = storeValues.filter(
          (item, i, ar) => ar.indexOf(item) === i,
        );
        if (this.validateEmail(storeValues[i])) {
          this.getmailIdvalues.push(storeValues[i]);
          this.filterSearchList.push({
            name: storeValues[i],
            value: storeValues[i],
          });
          this.validMailId = "";
        } else {
          Swal.fire({ text: "Enter valid Mail id" });
        }
      }
    }
  }
  validateEmail(email) {
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email,
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  removeFilter(filterName) {
    var index = this.filterSearchList.findIndex(function (item) {
      return item.name == filterName;
    });
    if (index > -1) {
      this.filterSearchList.splice(index, 1);
    }
  }

  ScheduleRep(event) {
    var target = event.target;
    if (target.checked) {
      this.ScheduleRepAccessability = target.id;
      if (this.ScheduleRepAccessability == "flexRadioDefault1") {
        this.ScheduleRepdailySelectedTypeNum = "1";
      } else if (this.ScheduleRepAccessability == "flexRadioDefault2") {
        this.ScheduleRepdailySelectedTypeNum = "2";
      }
    }
  }

  SheduleReportView() {
    this.scheduleRepName = this.selectedSavedReport.split(",")[1];
    if (
      this.selectedSavedReport == "" ||
      this.selectedSavedReport == undefined
    ) {
      Swal.fire({ text: "Please Select Report Type" });
      return false;
    }
    $("#saveEditScheduleName").val(this.selectedSavedReport.split(",")[1]);
  }

  saveScheduleReport(schedulerName) {
    if (this.selectedSavedReport.split(",")[2] == 5) {
      if (
        this.selectedSitIDItems == "" ||
        this.selectedSitIDItems == undefined
      ) {
        Swal.fire({ text: "Please Select Site" });
        return false;
      }
      if (
        this.FromDate == null ||
        this.FromDate == "" ||
        this.FromDate == undefined
      ) {
        Swal.fire({ text: "Please select From Date" });
        return false;
      }
      if (
        this.ToDate == null ||
        this.ToDate == undefined ||
        this.ToDate == ""
      ) {
        Swal.fire({ text: "Please select To Date" });
        return false;
      }
      this.RequestGenerateData = {
        SiteID: this.selectedSitIDItems,
        ReportID: this.selectedSavedReport.split(",")[0],
        TimeType: this.selectedSavedReport.split(",")[2],
        FromDate: this.FromDate,
        ToDate: this.ToDate,
      };
    }
    if (this.selectedSavedReport.split(",")[2] == 1) {
      this.SiteIdsDisplay = false;
      if (
        this.SelectedClustorZone == "" ||
        this.SelectedClustorZone == undefined
      ) {
        let textValue = "Please select the " + this.GetClustorZoneSieName;
        Swal.fire(textValue);
        return false;
      }
      if (
        this.FromDate == null ||
        this.FromDate == "" ||
        this.FromDate == undefined
      ) {
        Swal.fire({ text: "Please select the Date" });
        return false;
      }
      const allPossibleFormats = ["dd-MM-yyyy"];
      let startDt;
      let stdate = new Date(
        this.FromDate.year,
        this.FromDate.month - 1,
        this.FromDate.day,
      );
      this.standardStartDate = stdate;
      this.standardEndDate = stdate;
      if (moment(stdate, allPossibleFormats, true).isValid() == true) {
        startDt = this.datePipe.transform(stdate, "dd-MM-yyyy");
      } else {
        startDt = stdate;
      }
      this.FromDates = startDt.concat(" 00:00:00");
      this.EndDates = startDt.concat(" 23:59:59");
      this.RequestGenerateData = {
        Ids: this.SelectedClustorZone.join(),
        ReportID: this.selectedSavedReport.split(",")[0],
        TimeType: this.selectedSavedReport.split(",")[2],
        FromDate: this.FromDates,
        ToDate: this.EndDates,
      };
    }
    if (this.selectedSavedReport.split(",")[2] == 4) {
      this.SiteIdsDisplay = false;

      if (
        this.SelectedClustorZone == "" ||
        this.SelectedClustorZone == undefined
      ) {
        let textValue = "Please select the " + this.GetClustorZoneSieName;
        Swal.fire(textValue);
        return false;
      }
      this.FromToDateHistory = false;
      this.MonthHistory = true;
      this.RequestGenerateData = {
        Ids: this.SelectedClustorZone.join(),
        ReportID: this.selectedSavedReport.split(",")[0],
        TimeType: this.selectedSavedReport.split(",")[2],
        FromDate: this.selectedStartMonth,
        ToDate: this.selectedStartMonth,
      };
    }
    if (this.selectedSavedReport.split(",")[2] == 2) {
      this.SiteIdsDisplay = false;
      if (
        this.SelectedClustorZone == "" ||
        this.SelectedClustorZone == undefined
      ) {
        let textValue = "Please select the " + this.GetClustorZoneSieName;
        Swal.fire(textValue);
        return false;
      }

      this.RequestGenerateData = {
        Ids: this.SelectedClustorZone.join(),
        ReportID: this.selectedSavedReport.split(",")[0],
        TimeType: this.selectedSavedReport.split(",")[2],
        FromDate: "01-08-2021 00:00:00",
        ToDate: "04-08-2021 23:59:59",
      };
    }
    if (
      schedulerName == "" ||
      schedulerName == undefined ||
      schedulerName == null
    ) {
      Swal.fire({ text: "Please enter the report name !" });
      return false;
    }

    if (
      this.selectedgetEmailClass.length > 0 ||
      this.getmailIdvalues.length > 0
    ) {
      let selectedMailids = this.selectedgetEmailClass
        ? this.selectedgetEmailClass?.toString().replace(/[\[\]']+/g, '"')
        : "|";
      let selectedMailidssplitvalues = selectedMailids.split(",").join("|");
      this.saveShedRepJSON = {
        ReportAccessibility: this.ScheduleRepdailySelectedTypeNum,
        ApplicationEmailIds: selectedMailidssplitvalues,
        ExternalEmailIds: this.getmailIdvalues
          ? this.getmailIdvalues?.toString().replace(/[\[\]']+/g, '"')
          : "",
        ReportModule: 2,
        ReportEntity: this.RequestGenerateData,
      };
    } else {
      Swal.fire({ text: "Select Email or Enter new mail Address" });
    }
  }

  downloadPdf() {
    this.RequestGenerateData["PDF"] = 1;
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.getCustomReportPdf,
        this.RequestGenerateData,
      )
      .subscribe((res) => {
        const getImgResp: string = JSON.stringify(res.body);
        const resp = JSON.parse(getImgResp);
        if (resp.Status == "1") {
          FileSaver.saveAs(
            this.urlAuthentication.itocUrl + "PDFReports/" + resp.Message,
          );
        } else {
          alert(resp.Message);
        }
      });
  }
  datetimeformatHeaders(params) {
    if (params != "" && this.dateTimeFormat != undefined) {
      var date = new Date(params);
      if (this.dateTimeFormat.includes("tt")) {
        this.dateTimeFormat = this.dateTimeFormat.replace("tt", "a");
      }
      if (this.dateTimeFormat.includes("Decimal")) {
        this.dateTimeFormat = this.dateTimeFormat.replace(
          "HH:mm(Decimal)",
          "HH:mm",
        );
      }
      let fomateddate = this.datePipe.transform(date, this.dateTimeFormat);
      return fomateddate;
    }
  }
  ngOnDestroy() {
    this.modalService.dismissAll();
    $(".ag-paging-page-summary-panel").removeClass("remi");
  }
  onChartCreated(event: ChartCreated) {}
  onChartRangeSelectionChanged(event: ChartRangeSelectionChanged) {}
  onChartOptionsChanged(event: ChartOptionsChanged) {}
  onChartDestroyed(event: ChartDestroyed) {}
  _toggleSidebar() {
    this._opened = !this._opened;
  }
  public toggleSidebar($event) {
    this.sideBar = $event.target.checked;
  }
  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }

  onBtLast() {
    this.pageIndex += 1;
    this.generateSavedReport();
    this.gridApi.paginationSetPageSize(this.gridRecordSize);
  }
  onBtNext() {
    this.gridApi.paginationGoToNextPage();
  }

  onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage();
  }
  tenantList() {
    const siteRequest = {
      fmID: 10012,
      siteID: this.selectedSitIDItems?.toString(),
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchTenant = [];
          let tenant = resp.response[0].Data;
          this.searchTenant = tenant.filter((item) => item.ID && item.Name);
        },
        (error) => {
          console.error(error);
        },
      );
  }

  powerplantList() {
    const siteRequest = {
      fmID: 10013,
      siteID: this.selectedSitIDItems?.toString(),
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchPowerPlant = [];
          let powerPlant = resp.response[0].Data;
          this.searchPowerPlant = powerPlant.filter(
            (item) => item.ID && item.Name,
          );
        },
        (error) => {
          console.error(error);
        },
      );
  }

  controllerList() {
    const siteRequest = {
      fmID: 10014,
      siteID: this.selectedSitIDItems?.toString(),
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchController = [];
          this.searchController = resp.response[0].Data;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  genControllerList() {
    const siteRequest = {
      fmID: 10014,
      siteID: this.selectedSitIDItems?.toString(),
      TenantClassif: "2",
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchGeneratorController = [];
          this.searchGeneratorController = resp.response[0].Data;
        },
        (error) => {
          console.error(error);
        },
      );
  }
  rectControllerList() {
    const siteRequest = {
      fmID: 10014,
      siteID: this.selectedSitIDItems?.toString(),
      TenantClassif: "7",
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchRectifierController = [];
          this.searchRectifierController = resp.response[0].Data;
        },
        (error) => {
          console.error(error);
        },
      );
  }
  batControllerList() {
    const siteRequest = {
      fmID: 10014,
      siteID: this.selectedSitIDItems?.toString(),
      TenantClassif: "8",
    };
    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, siteRequest)
      .subscribe(
        (resp) => {
          this.searchBatteryController = [];
          this.searchBatteryController = resp.response[0].Data;
        },
        (error) => {
          console.error(error);
        },
      );
  }
  timeTypeChanged() {
    this.selectedDateRange = "";
    this.selectedStartMonth = undefined;
    this.selectedWeek = undefined;
    this.fromDate = "";
    this.toDate = "";
    switch (this.selectedTimeType) {
      case "1":
        this.showdateTimePicker = true;
        this.showMonthlyDD = false;
        this.showWeeklyDD = false;
        break;
      case "2":
        this.showdateTimePicker = false;
        this.showMonthlyDD = true;
        this.showWeeklyDD = false;
        break;
      case "3":
        this.showdateTimePicker = false;
        this.showMonthlyDD = false;
        this.showWeeklyDD = true;
        break;
      default:
        break;
    }
  }

  getEquipments() {
    const reportcat = this.reportCatageryType == 2 ? "1,3" : "2";
    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi + this.apiUrl.getEquipments,
        { reportcategory: reportcat, reporttype: this.reportCatageryType },
      )
      .subscribe(
        (res) => {
          this.EquipDropdown = res.response;
          this.EquipmentDropdown = true;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  getEquipColms(equipmentID, str, reportType) {
    let dataValue = {
      fmid: equipmentID,
      reportcategoryid: reportType,
    };
    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi + this.apiUrl.getEquipColumns,
        dataValue,
      )
      .subscribe(
        (res) => {
          const rawColumns: any[] = res.response[0]?.Columns || [];

          // exclude hidden columns
          const visibleColumns = rawColumns
            .filter((col: any) => col.visible !== 0)
            .map((col: any) => ({
              ...col,
              equipID: equipmentID,
              fieldaliasname: col.displayname,
              isChecked: col.iscommon === 1,
              isDisabled: col.iscommon === 1,
            }));

          this.tableColumns = [];

          // mandatory columns auto-added to payload
          visibleColumns
            .filter((col: any) => col.iscommon === 1)
            .forEach((col: any) => {
              this.tableColumns.push({ columnid: col.columnid, groupBy: "0" });
            });

          this.Columns.push({
            equipmentID: equipmentID,
            tableColumns: this.tableColumns,
          });

          let _val = this.getHeaders();
          this.switchF(_val, visibleColumns, str);
        },
        (error) => {
          console.error(error);
        },
      );
  }

  submitSavedCustomReport() {
    if (
      this.reportname == "" ||
      this.reportname == undefined ||
      this.reportname.trim() == ""
    ) {
      Swal.fire({ text: "Please Enter Report Name" });
      return false;
    }

    const reports = this.Columns.map((item: any) => ({
      reportid: item.equipmentID,
      columns: item.tableColumns.map((col: any) => Number(col.columnid)),
    }));

    this.customReportRequestJson = {
      reportname: `${this.addRetportTypeText.trim()} - ${this.reportname.trim()}`,
      reports: reports,
    };

    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi +
          this.apiUrl.saveCustomReports,
        this.customReportRequestJson,
      )
      .subscribe(
        (res) => {
          let GetRport = res;
          if (res.code === 200) {
            Swal.fire({
              text: res.response.reportName + " saved successfully.",
              icon: "success",
            });
            this.modalService.dismissAll();
            this.selectedReportType = "0";
            this.Header1 = false;
            this.Header2 = false;
            this.Header3 = false;
            this.Header4 = false;
            this.Header5 = false;
            this.Header6 = false;
            this.Header7 = false;
            this.Header8 = false;
            this.Header9 = false;
            this.Header10 = false;
            this.Header11 = false;
            this.Switch = false;
            this.hideCircleClustorDropdown = false;
            this.EquipmentDropdown = false;
            this.Columns = [];
            this.selectedItems = [];
            this.EquipmentIds = [];
            this.count = 0;
            $(".rptype").addClass("rptype");
            this.fetchSavedRepoprt();
          } else {
            Swal.fire({
              text: GetRport.status,
              icon: "warning",
            });
          }
        },
        (error) => {
          console.error(error);
        },
      );
    this.reportname = "";
  }

  publishSavedReport(content) {
    this.selectedPublishUserType = "";
    this.selectedPublishUser = [];
    this.getUserTypes();
    this.getUsers();
    this.modalService.open(content, { size: "md" });
  }

  onPublish(modal) {
    const publishPayload = {
      reportid: this.selectedSavedReportId,
      reportname: this.selectedReportName,
      publishToUser: this.selectedPublishUser?.length
        ? this.selectedPublishUser.join(", ")
        : "",
      publishToType:
        this.selectedPublishUserType != null &&
        this.selectedPublishUserType !== ""
          ? String(this.selectedPublishUserType)
          : "",
    };
    this.http
      .post(
        this.urlAuthentication.reportsGenerateApi + this.apiUrl.publishReport,
        publishPayload,
      )
      .subscribe(
        (res) => {
          if (res.code === 200) {
            Swal.fire({ text: res.response.status, icon: "success" });
            modal.close();
          } else {
            Swal.fire({ text: res.status, icon: "warning" });
          }
        },
        (error) => {
          console.error(error);
          Swal.fire({ text: "Failed to publish report.", icon: "error" });
        },
      );
  }

  getUserTypes() {
    this.http
      .post(this.urlAuthentication.newMastersUrl + this.apiUrl.getUserType, {})
      .subscribe(
        (res) => {
          this.userTypes = [];
          this.userTypes = res.response;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  onUserTypeChange(ev) {
    this.selectedPublishUser = [];
    if (ev) {
      this.getUsers(ev.ID);
    } else {
      this.getUsers();
    }
  }

  getUsers(userTypeId?: any) {
    const baseUrl = this.urlAuthentication.newMastersUrl + this.apiUrl.getUsers;
    const url = userTypeId ? `${baseUrl}?UserTypeID=${userTypeId}` : baseUrl;
    this.http.post(url, {}).subscribe(
      (res) => {
        this.users = [];
        this.users = res.response;
      },
      (error) => {
        console.error(error);
      },
    );
  }
}
